

import { Card } from '@/src/components/ui/shadcn/card';
import { Rocket, ChevronRight, Brain, Sparkles } from 'lucide-react';
import { Badge } from '@/src/components/ui/shadcn/badge';

/**
 * Clickster Command Center spotlight card.
 * Links to the main dashboard.
 */
export function DashboardSpotlight() {
  const handleClick = () => {
    window.open('/dashboard', '_blank');
  };

  return (
    <Card
      className="w-full cursor-pointer transition-colors overflow-hidden relative group"
      onClick={handleClick}
      data-testid="spotlight-dashboard-card"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), handleClick())}
      aria-label="Open Clickster Command Center"
    >
      <div className="absolute inset-0 bg-transparent dark:bg-gray-800" />
      <div className="absolute inset-0 bg-gray-100/50 dark:bg-gray-700 opacity-0 group-hover:opacity-100 transition-opacity" />

      <div className="p-4 relative flex flex-col gap-1">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 shrink-0">
            <Rocket className="w-4 h-4 text-muted-foreground" />
            <h3 className="text-sm font-medium text-foreground">Clickster Command Center</h3>
          </div>
          <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0" />
        </div>

        <p className="text-sm text-muted-foreground pl-6">
          Your command center for campaign performance and insights
        </p>
      </div>
    </Card>
  );
}

/**
 * AI Workflow spotlight card.
 * Links to the workflows page.
 */
export function AIWorkflowSpotlight() {
  const handleClick = () => {
    window.open('/workflows', '_blank');
  };

  return (
    <Card
      className="w-full cursor-pointer transition-colors overflow-hidden relative group"
      onClick={handleClick}
      data-testid="spotlight-ai-workflow-card"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), handleClick())}
      aria-label="Open AI Workflow"
    >
      <div className="absolute inset-0 bg-transparent dark:bg-gray-800" />
      <div className="absolute inset-0 bg-gray-100/50 dark:bg-gray-700 opacity-0 group-hover:opacity-100 transition-opacity" />

      <div className="p-4 relative flex flex-col gap-1">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 shrink-0">
            <Brain className="w-4 h-4 text-muted-foreground" />
            <h3 className="text-sm font-medium text-foreground">AI Workflow</h3>
            <Badge
              variant="secondary"
              className="rounded-md px-2 py-0.5 text-xs font-medium bg-blue-500/10 text-blue-600 dark:text-blue-400"
            >
              <div className="flex items-center gap-1">
                <Sparkles className="w-3 h-3" />
                New
              </div>
            </Badge>
          </div>
          <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0" />
        </div>

        <p className="text-sm text-muted-foreground pl-6">
          Manage AI development tasks with an intelligent kanban board
        </p>
      </div>
    </Card>
  );
}
